function togglePassword(inputId: string, button: HTMLElement): void {
  const passwordInput = document.getElementById(inputId) as HTMLInputElement;
  const icon = button.querySelector('i');

  if (!passwordInput || !icon) {
    return;
  }

  if (passwordInput.type === 'password') {
    passwordInput.type = 'text';
    button.setAttribute('aria-label', 'Hide password');
    button.setAttribute('title', 'Hide password');
    icon.classList.remove('ti-eye');
    icon.classList.add('ti-eye-off');
  } else {
    passwordInput.type = 'password';
    button.setAttribute('aria-label', 'Show password');
    button.setAttribute('title', 'Show password');
    icon.classList.remove('ti-eye-off');
    icon.classList.add('ti-eye');
  }
}

export function initPasswordReveal(): void {
  const toggleButtons = document.querySelectorAll('[data-password-reveal]');

  toggleButtons.forEach(button => {
    const targetId = button.getAttribute('data-password-reveal');
    if (targetId) {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        togglePassword(targetId, button as HTMLElement);
      });
    }
  });
}
